var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v(_vm._s(_vm.$t('ticket_claimed')))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }